'use client';

import { useEffect, useState } from 'react';
import { useTradeContext } from '../TradePageClient/TradePageClient';
import styles from './QuantityCounter.module.scss';

export type QuantityCounterProps = {
  initialQuantity?: number;
  acquiredCount?: number;
  goodId: string;
  disabled?: boolean;
  tradeableInCount?: number; // ラベル全体の最大選択可能数
  totalSelectedInLabel?: number; // 同一ラベル内の選択合計数
  isPastDeadline?: boolean; // 期日超過フラグ
};

function QuantityCounter({
  initialQuantity = 0,
  acquiredCount,
  goodId,
  disabled = false,
  tradeableInCount,
  totalSelectedInLabel,
  isPastDeadline = false,
}: QuantityCounterProps) {
  const { setSelectedItems } = useTradeContext();
  const [quantity, setQuantity] = useState(initialQuantity);

  // 同一ラベル内の選択合計数（外部から渡される値を使用）
  const labelTotalSelected = totalSelectedInLabel || 0;

  useEffect(() => {
    setSelectedItems((prevItems) => {
      const newMap = new Map(prevItems);
      newMap.set(goodId, quantity);
      return newMap;
    });
  }, [quantity, goodId, setSelectedItems]);

  const handleIncrease = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const handleDecrease = () => {
    if (quantity > 0) {
      setQuantity((prevQuantity) => prevQuantity - 1);
    }
  };

  return (
    <div className={styles.container}>
      <button
        type='button'
        className={`${styles.button} ${styles.decrease}`}
        onClick={handleDecrease}
        disabled={disabled || quantity <= 0 || isPastDeadline}
      >
        -
      </button>

      <div className={`${styles.quantity} ${isPastDeadline ? styles.pastDeadline : ''}`}>{quantity}</div>

      <button
        type='button'
        className={`${styles.button} ${styles.increase}`}
        onClick={handleIncrease}
        disabled={
          disabled ||
          isPastDeadline ||
          (tradeableInCount !== undefined
            ? labelTotalSelected >= tradeableInCount
            : acquiredCount !== undefined && quantity >= acquiredCount)
        }
      >
        +
      </button>
    </div>
  );
}

export default QuantityCounter;
